// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"2a38b9dc209196316db6","655":"0a71de6163dcd568d3f5"}[chunkId] + ".js";
};